export default {
  MOUSE_DOWN: 'mousedown',
  MOUSE_MOVE: 'mousemove',
  MOUSE_UP: 'mouseup',

  TOUCH_START: 'touchstart',
  TOUCH_MOVE: 'touchmove',
  TOUCH_END: 'touchend',

  KEY_UP: 'keyup',
  KEY_DOWN: 'keydown',
  KEY_PRESS: 'keypress',

  SCROLL: 'scroll',
  RESIZE: 'resize',
  CLICK: 'click',
};
